if (!window.Vue) {
	require('./bootstrap');
}

import Modal from './components/Modal.vue'
import ReportIssue from './components/ReportIssue.vue'

Vue.component('report-issue', ReportIssue)
Vue.component('modal', Modal)

var reportIssueApp = new Vue({

	el: "#beta-footer",

	data: {
		showReportIssueForm: false,
	},


})